<template>
  <base-layout>
    <template v-slot:header>
      <router-view></router-view>
      <h1 class="text-3xl font-bold leading-tight text-gray-900">
        Edukacija
      </h1>
    </template>
    <template v-slot:default>
      <div class="space-y-8 divide-y divide-gray-200 sm:space-y-5 mb-5">
        <div>
          <div>
            <h3 class="text-lg leading-6 font-medium text-gray-900">
              Test: {{ quiz.quiz }}
            </h3>
            <p
              class="mt-1 max-w-4xl text-sm text-gray-500"
              v-if="quiz.answers && quiz.answers.length === quizCount"
            >
              Uspešno ste završili kviz!
            </p>
            <p class="mt-1 max-w-4xl text-sm text-gray-500" v-else>
              Proverite svoje znanje iz zadatih oblasti. Svaki test se može
              uraditi samo jednom, a ostvaren broj poena po testu će biti
              vidljiv naknadno.
            </p>
          </div>
        </div>
      </div>
      <div
        class="space-y-8 sm:space-y-5 mb-5 h-auto"
        v-if="quiz.answers && quiz.answers.length !== quizCount"
      >
        <div
          class="divide-y divide-gray-200 pt-8 space-y-6 sm:pt-10 sm:space-y-5"
        >
          <div>
            <h3 class="text-lg leading-6 font-medium text-gray-900">
              {{ answer.question }}
            </h3>
            <p class="mt-1 max-w-2xl text-sm text-gray-500">
              Odaberite jedan ili više odgovora. Samo pitanja u kojima su
              označeni svi tačni odgovori, bez netačnih, se računaju kao tačna.
            </p>
          </div>
          <div class="space-y-6 sm:space-y-5 divide-y divide-gray-200">
            <div class="pt-6 sm:pt-5">
              <div role="group" aria-labelledby="label-email">
                <div class="sm:grid sm:grid-cols-3 sm:gap-4 sm:items-baseline">
                  <div>
                    <div
                      class="text-base font-medium text-gray-900 sm:text-sm sm:text-gray-700"
                      id="label-email"
                    >
                      Ponuđeni odgovori
                    </div>
                  </div>
                  <div class="mt-4 sm:mt-0 sm:col-span-2">
                    <div class="max-w-lg space-y-4">
                      <div class="relative flex items-start">
                        <div class="flex items-center h-5">
                          <input
                            id="comments_0"
                            type="checkbox"
                            v-model="answers"
                            value="0"
                            class="focus:ring-indigo-500 h-4 w-4 text-indigo-600 border-gray-300 rounded cursor-pointer"
                          />
                        </div>
                        <div class="ml-3 text-sm">
                          <label
                            for="comments_0"
                            class="font-medium text-gray-700 cursor-pointer"
                            >{{ answer.answer_1 }}</label
                          >
                        </div>
                      </div>
                      <div
                        class="relative flex items-start"
                        v-if="answer.answer_2"
                      >
                        <div class="flex items-center h-5">
                          <input
                            id="comments_1"
                            type="checkbox"
                            v-model="answers"
                            value="1"
                            class="focus:ring-indigo-500 h-4 w-4 text-indigo-600 border-gray-300 rounded cursor-pointer"
                          />
                        </div>
                        <div class="ml-3 text-sm">
                          <label
                            for="comments_1"
                            class="font-medium text-gray-700 cursor-pointer"
                            >{{ answer.answer_2 }}</label
                          >
                        </div>
                      </div>

                      <div
                        class="relative flex items-start"
                        v-if="answer.answer_3"
                      >
                        <div class="flex items-center h-5">
                          <input
                            id="comments_2"
                            type="checkbox"
                            v-model="answers"
                            value="2"
                            class="focus:ring-indigo-500 h-4 w-4 text-indigo-600 border-gray-300 rounded cursor-pointer"
                          />
                        </div>
                        <div class="ml-3 text-sm">
                          <label
                            for="comments_2"
                            class="font-medium text-gray-700 cursor-pointer"
                            >{{ answer.answer_3 }}</label
                          >
                        </div>
                      </div>

                      <div
                        class="relative flex items-start"
                        v-if="answer.answer_4"
                      >
                        <div class="flex items-center h-5">
                          <input
                            id="comments_3"
                            type="checkbox"
                            v-model="answers"
                            value="3"
                            class="focus:ring-indigo-500 h-4 w-4 text-indigo-600 border-gray-300 rounded cursor-pointer"
                          />
                        </div>
                        <div class="ml-3 text-sm">
                          <label
                            for="comments_3"
                            class="font-medium text-gray-700 cursor-pointer"
                            >{{ answer.answer_4 }}</label
                          >
                        </div>
                      </div>

                      <div
                        class="relative flex items-start"
                        v-if="answer.answer_5"
                      >
                        <div class="flex items-center h-5">
                          <input
                            id="comments_4"
                            type="checkbox"
                            v-model="answers"
                            value="4"
                            class="focus:ring-indigo-500 h-4 w-4 text-indigo-600 border-gray-300 rounded cursor-pointer"
                          />
                        </div>
                        <div class="ml-3 text-sm">
                          <label
                            for="comments_4"
                            class="font-medium text-gray-700 cursor-pointer"
                            >{{ answer.answer_5 }}</label
                          >
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="pt-5">
        <div class="flex justify-start">
          <a
            v-if="quiz.answers && quiz.answers.length !== quizCount"
            type="button"
            @click.prevent="saveAnswer(answer.id)"
            class="bg-white py-2 px-4 border border-gray-300 rounded-md shadow-sm text-sm font-medium text-gray-700 hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 cursor-pointer"
          >
            Potvrdi
          </a>
          <router-link
            v-else
            type="button"
            to="/education/tests/"
            class="bg-white py-2 px-4 border border-gray-300 rounded-md shadow-sm text-sm font-medium text-gray-700 hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 cursor-pointer"
          >
            Nazad na testove
          </router-link>
        </div>
      </div>
    </template>
  </base-layout>
</template>

<script>
import EducationTest from "./EducationTest";
export default EducationTest;
</script>
